import type { Account } from '@api/hooks/useAccounts';

import { getAmountLabel } from '../utils';
import { AccountInfo } from './AccountInfo';
import { AccountInfoMobile } from './AccountInfoMobile';

export const AvailableBalanceCell = ({ availableBalance, status }: Account) => (
	<span className="text-sm-bold">{getAmountLabel(availableBalance, status)}</span>
);

export const AccountCellDesktop = (accountProps: Account) => (
	<AccountInfo {...accountProps} />
);

export const AccountCellMobile = (accountProps: Account) => (
	<AccountInfoMobile account={accountProps} />
);
